import { msg } from '@lingui/core/macro';
import type { LanguageRuntime } from './runtime';

export const connectDocumentTitle = (runtime: LanguageRuntime, entry: 'user' | 'admin', target = document) => {
  const sourceTitle = entry === 'admin' ? 'Borgee Admin' : 'Borgee';
  const suffix = target.title.startsWith(sourceTitle) ? target.title.slice(sourceTitle.length) : '';
  const update = () => {
    target.title = (entry === 'admin' ? runtime.i18n._(msg`Borgee Admin`) : 'Borgee') + suffix;
  };
  update();
  return runtime.subscribe(update);
};
